import { render, staticRenderFns } from "./transaction-strongbox.vue?vue&type=template&id=77543dcf&"
import script from "./transaction-strongbox.vue?vue&type=script&lang=js&"
export * from "./transaction-strongbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports